/**
 * Application Color Scheme
 *
 * This file contains the centralized color palette for the entire application.
 * To change the theme, modify the values in this file, and the changes will
 * propagate throughout the application.
 *
 * Key Areas to Customize:
 * - primary.background: Header backgrounds (currently matches PPE logo gray)
 * - primary.hover: Header hover states
 * - accent.blue: Primary action buttons and interactive elements
 * - accent.blueHover: Button hover states
 */
export const colors = {
	primary: {
		background: "#9BA3B0", // Medium gray matching PPE intelligence logo background
		hover: "#868E9B", // Darker shade for hover states
		text: "#ffffff", // White text for contrast on gray background
		textDark: "#1e293b", // Dark text alternative for lighter backgrounds
	},
	secondary: {
		background: "#f8fafc", // Light grey for content areas
		text: "#475569", // Medium gray text
	},
	accent: {
		blue: "#3b82f6", // Primary interactive elements
		blueHover: "#2563eb", // Hover state for blue elements
		blueDark: "#1e40af", // Active/pressed state for blue elements
		green: "#10b981", // Success/positive values
		greenHover: "#059669", // Hover state for green elements
		yellow: "#f59e0b", // Draft status / warnings
		yellowHover: "#d97706", // Hover state for yellow elements
		red: "#ef4444", // Error/negative values
		redHover: "#dc2626", // Hover state for red elements
	},
	neutral: {
		white: "#ffffff",
		grey: {
			50: "#f8fafc",
			100: "#f1f5f9",
			200: "#e2e8f0",
			300: "#cbd5e1",
			400: "#94a3b8",
			500: "#64748b",
			600: "#475569",
			700: "#334155",
			800: "#1e293b",
			900: "#0f172a",
		},
		black: "#000000",
	},
	status: {
		approved: "#10b981",
		draft: "#f59e0b",
		weekend: "#cbd5e1",
		today: "#3b82f6",
	},
	pastel: {
		yellow: "#FFF9C4", // No hours entered - soft warm yellow
		red: "#FFE5E5", // Hours mismatch - soft red
		green: "#C8E6C9", // Hours matching - soft green
		gray: "#F5F5F5", // Holiday - soft gray
		yellowWeek: "#FFF9C4", // Week complete but open - brighter soft yellow
		greenWeek: "#C8E6C9", // Week closed - brighter soft green
		brown: "#D7CCC8", // Absence (task_code 1 internal) - soft brown
		brownDark: "#8D6E63", // Vacation (task_code 2 internal) - darker brown
	},
} as const;

export type ColorScheme = typeof colors;
